var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/smallscreen-swatch-truncation.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "truncateSwatches") && ((env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "products")),"skuInfo")),"primarySlice")),"sliceItems"))) > 1)) {
output += "<span class=\"u-clearfix u-medium--hide\">\n        <a class=\"o-list-swatches__more\" href=\"";
output += runtime.suppressValue((lineno = 4, colno = 58, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "productUrl"), "productUrl", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "products")),"product")),"productSlug")])), env.opts.autoescape);
output += "\" title=\"";
output += runtime.suppressValue((lineno = 4, colno = 100, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_tile-swatch-title",runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "products")),"skuInfo")),"primarySlice")),"displayLabel")]})])), env.opts.autoescape);
output += "\" data-qa-more-swatches>\n            + ";
output += runtime.suppressValue(env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "products")),"skuInfo")),"primarySlice")),"sliceItems")), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((lineno = 5, colno = 66, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["swatch-truncation"])), env.opts.autoescape);
output += "\n        </a>\n    </span>";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/smallscreen-swatch-truncation.j2"] , dependencies)